import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import { BgColor } from 'tbk-components/src/components/Core/colors';
import { Positions, positionsMap } from 'tbk-components/src/components/Core/positions';
import { BackgroundSizes } from 'tbk-components/src/components/Core/sizes';
import { IImage } from 'tbk-components/src/components/Image';

export interface IContainerProps extends IBaseElementProps {
	size?: '' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | 'fluid';
	backgroundColor?: BgColor;
	/**
	 * Background Image
	 * @size full
	 */
	backgroundImage?: IImage;
	backgroundPosition?: Positions;
	backgroundSize?: BackgroundSizes | string;
	children?: any;
}

/**
 * Container
 * @block
 * @requiresHooks
 */
const Container: React.FC<IContainerProps> = ({
	children,
	backgroundColor,
	backgroundImage,
	className,
	classNames = [],
	size = '',
	backgroundPosition = 'center',
	backgroundSize = 'cover',
	id,
}) => (
	<div
		className={
			className ||
			cn(
				`container${size ? `-${size}` : ''}`,
				backgroundColor && `bg-${backgroundColor}`,
				backgroundColor === 'dark' && 'text-light',
				...classNames,
			)
		}
		style={{
			backgroundPosition: positionsMap[backgroundPosition] || 'center',
			backgroundSize,
			...(backgroundImage
				? { backgroundImage: `url('${backgroundImage.src}')` }
				: {}),
		}}
		id={id}
	>
		{backgroundImage && backgroundColor && (
			<div
				className={cn('container-overlay', `bg-${backgroundColor}`)}
			></div>
		)}
		{children}
	</div>
);

export default Container;
